import styled from "styled-components";

export const TextPageContainer = styled.div`
    width: 100%;
    padding: 5% 5vw;

    h1 {
        margin-bottom: 1rem;
    }

    h2 {
        margin-bottom: 1rem;
        line-height: 1.8rem;
    }

    p {
        line-height: 1.5rem;
        margin: 0.5rem 0;
    }
`;
